import React, { Fragment, useState, useEffect } from 'react'
import { apiWrapWithErrorWithData } from '../../utils/apiWrapper';
import { getAllJobs,recordCreditPaymentReceived,ExportCsv } from '../../Redux/Actions/corporateJobs';
import DataTable from '../../utils/dataTable';
import { getAllServices } from '../../Redux/Actions/jobs';
import DropDown from "../Ui/DropDown";
import Loader from "react-loader-spinner";
// import * as refundActions from '../../Redux/Actions/refunds';
import LoadingButton from "../../utils/loadingButton";
import { corporateCompanyJobPaymentVoucher } from '../../Redux/Actions/paymentLink';
import { toastMessage } from '../../utils/toast';
import { useTranslation } from "react-i18next";
import { toast } from 'react-toastify';
import { Modal, Button } from 'antd';

toast.configure();


const paymentTypeList = [
  { label: "Cash", value: "0" },
  { label: "Online", value: "1" },
  { label: "Credit", value: "2" },
  { label: "Bank Transfer", value: "3" },
];

const paymentStatusList = [
  { label: "Pending", value: "Pending" },
  { label: "Completed", value: "Completed" },
];

function CorporateJobs({ history }) {
  const { t } = useTranslation();
  const [jobs, setJobs] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [companyName, setCompanyName] = useState('');
  const [departmentId, setDepartmentId] = useState("");
  const [dueDateStart, setDueDateStart] = useState("");
  const [dueDateEnd, setDueDateEnd] = useState("");
  const [masterProcessId, setMasterProcessId] = useState("");
  const [processId, setProcessId] = useState("");
  const [processList, setProcessList] = useState([]);
  const [departmentList, setDepartmentList] = useState([]);
  const [masterProcessList, setMasterProcessList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [payVoucherLoading, setPayVoucherLoading] = useState(false);
  const [buttonLoading, setButtonLoading] = useState(false);
  const { confirm } = Modal;

  const [selectedPaymentType, setSelectedPaymentType] = useState("");
  const [selectedPaymentStatus, setSelectedPaymentStatus] = useState("");

  useEffect(() => {
    getMasterProcessApi();
  }, []);

  useEffect(() => {
    getAllJobsApi(currentPage, companyName, departmentId?.value, masterProcessId?.value, processId?.value, selectedPaymentType?.value, selectedPaymentStatus?.value, dueDateStart, dueDateEnd);
  }, [currentPage]);

  const getAllJobsApi = async (page = 0, companyName = "", departmentId = "", masterProcessId = "", processId = "", selectedPaymentType = "", selectedPaymentStatus = "", dueDateStart = "", dueDateEnd = "") => {

    try {
      const response = await apiWrapWithErrorWithData(
        getAllJobs({
          companyName,
          departmentId,
          masterProcessId,
          processId,
          page,
          selectedPaymentType,
          selectedPaymentStatus,
          dueDateStart,
          dueDateEnd
        }));
      if (response?.data) {
        setJobs(response.data?.companyJobs);
        setTotalCount(response.data?.totalCount);
      }
    } catch (error) {
      console.log("getAllJobsApi", error);
    }
  };

  const handleList = (key, ID) => {
    let list = [];
    if (key === "department") {
      list = departmentList.filter(({ value }) => value === ID)[0]
        .masterProcess;
      list = list.map(({ name, id, process }) => ({
        label: name,
        value: id,
        process: process,
      }));
      list.unshift({ label: "Select Department", value: 0, process: [] });
      setMasterProcessList(list);
      setProcessList([]);
      setMasterProcessId("");
      setProcessId("");
      setSelectedPaymentType("");
      setSelectedPaymentStatus("");
      setDueDateStart("");
      setDueDateEnd("");
    } else {
      list = masterProcessList.filter(({ value }) => value === ID)[0].process;
      list = list.map(({ name, id }) => ({ label: name, value: id }));
      list.unshift({ label: "Select Master process", value: 0 });
      setProcessList(list);
    }
  };

  const getMasterProcessApi = async () => {
    const response = await apiWrapWithErrorWithData(getAllServices());
    let departmentsList = response.departments;
    departmentsList = departmentsList.map(({ name, id, masterProcess }) => ({
      label: name,
      value: id,
      masterProcess: masterProcess,
    }));
    departmentsList.unshift({
      label: "Select Department",
      value: 0,
      masterProcess: [],
    });
    setDepartmentList(departmentsList);
  };

  const handleSubmit = async () => {

    setIsLoading(true);
    await getAllJobsApi(0, companyName, departmentId?.value, masterProcessId?.value, processId?.value, selectedPaymentType?.value, selectedPaymentStatus?.value, dueDateStart, dueDateEnd);
    setIsLoading(false);
  }

  const handleClear = () => {
    setDepartmentId("")
    setMasterProcessId("")
    setProcessId("")
    setCompanyName("")
    setSelectedPaymentStatus("")
    setSelectedPaymentType("")
    setCurrentPage(0)
    getAllJobsApi()
    setDueDateStart("")
    setDueDateEnd("")
  }

  const columns = [
    {
      Header: "Id",
      accessor: "id",
    },
    {
      Header: "Job Reference",
      accessor: "corporateJobReference",
    },
    {
      Header: "Company name",
      accessor: "companyName"
    },
    {
      Header: "Job info",
      Cell: ({ cell }) => (
        <div>
          {cell.row.original.id && (
            <div>
              <strong>D</strong> <strong>:</strong> {cell.row.original.departmentName} <br />
              <strong>M</strong> <strong>:</strong> {cell.row.original.masterProcessName}<br />
              <strong>P</strong> <strong>:</strong> {cell.row.original.processName}<br />
              <strong>Job count</strong> <strong>:</strong> {cell.row.original.jobCount}
            </div>)}
        </div>
      )
    },
    {
      Header: "Payment",
      Cell: ({ cell }) => (
        <div>
          {cell.row.original.id && (
            <div>
              <strong>Type</strong> <strong>:</strong> {cell.row.original.paymentTypeValue} <br />
              <strong>Status</strong> <strong>:</strong> {cell.row.original.paymentStatus}<br />
              <strong>Payment Date</strong> <strong>:</strong> {cell.row.original.paymentCompletedDate}<br />
              <strong>Due Date</strong> <strong>:</strong> {cell.row.original.dueDate || '-'}
            </div>)}
        </div>
      )
    },
    {
      Header: "Payment Approval",
      Cell: ({ cell }) => (
        <div>
          {cell.row.original.paymentTypeValue != "Online" && (
            <div>
              <strong>Status</strong> <strong>:</strong> {cell.row.original.pmtApprovalStatus}<br />
              <strong>Approved by</strong> <strong>:</strong> {cell.row.original.pmtApprovedBy}<br />
              <strong>Description</strong> <strong>:</strong> {cell.row.original.pmtApprovedNotes || '-'}
            </div>)}
        </div>
      )
    },
    {
      Header: "Job status",
      accessor: "status",
    },
    {
      Header: "Po Number",
      accessor: "poNumber"
    },
    {
      Header: "Action",
      accessor: "processId",
      Cell: ({ cell }) => (
        <div className='d-flex gap-3'>
          {cell.row.original.id && (
            <button
              className="json-button btn btn-sm btn-primary"
              onClick={() => history.push(`/corporate-jobs/${cell.row.original.id}`)}
            >
              {"View"}
            </button>
          )}
       {cell.row.original.id && cell.row.original.isShowRecordPaymentStatusUpdate &&(
  <button
    className="json-button btn btn-sm btn-primary"
    onClick={() => {
      confirm({
        title: 'Confirm Payment Update',
        content: 'Are you sure you want to update the payment status to complete?',
        onOk() {
          recordCreditPaymentReceivedSubmit(JSON.stringify(cell.row.original.id));
        },
        onCancel() {
          console.log('Cancelled');
        },
      });
    }}
  >
    {"Credit payment status update"}
  </button>
)}
          {cell.row.original.paymentStatus === "Completed" && (
            <button
              className="json-button btn btn-sm btn-primary"
              onClick={() => paymentVoucherHandler(cell.row.original.id)}
            >
              {"Payment voucher"}
            </button>
          )}

        </div>
      ),
    },
  ];

  const recordCreditPaymentReceivedSubmit = async (id) => {
    // setPayVoucherLoading(true);
   
    try {
      const requestData= {
        corporateCompanyJobId:id
      };
      const response = await recordCreditPaymentReceived(requestData);
      if(response.status==200){
        toast.success(response.data.message, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 3000, 
        });
        getAllJobsApi(currentPage, companyName, departmentId?.value, masterProcessId?.value, processId?.value, selectedPaymentType?.value, selectedPaymentStatus?.value, dueDateStart, dueDateEnd);
      }else{
        var errorMsg=response.data.message ? response.data.message:"Somthing went wrong";
        toast.error(errorMsg, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 3000, 
        });
      }
     
    } catch (err) {
      toast.error(err, {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 3000, 
      });
    }
    // setPayVoucherLoading(false);
  }
  
  
  const paymentVoucherHandler = async (id) => {
    setPayVoucherLoading(true);
    try {
      const response = await corporateCompanyJobPaymentVoucher(id);
      const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
      const link = document.createElement('a');
      link.href = url;
      var filename = "AMPL-" + id;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
    } catch (err) {
      console.log(err);
    }
    setPayVoucherLoading(false);
  }

  const handleExport = () => {
    setButtonLoading(true);
    const payload = {
      Department: departmentId?.value || "",
      Process: processId?.value || "",
      MasterProcess: masterProcessId?.value || "",
      Company: companyName || "",
      PaymentType: selectedPaymentType?.value || "",
      PaymentStatus: selectedPaymentStatus?.value || "",
      DueDateStart: dueDateStart || "",
      DueDateEnd: dueDateEnd || ""
    };
    ExportCsv(payload)
      .then(res => {
        if (res.data) {
          try {
            const uniqueId = res.data.uniqueId || Date.now();
            const fileName = `CorporateCompanyJobs_${uniqueId}.csv`;
            const blob = new Blob(["\ufeff", res.data], { type: 'text/csv;charset=utf-8;' });
            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            toastMessage('info', 'Download successful');
          } catch (error) {
            console.error("Download Error:", error);
            toastMessage('error', 'Something went wrong during file download!');
          }
        } else {
          toastMessage('warning', 'No data available for download');
        }
      })
      .catch(err => {
        console.error("API Error:", err);
        toastMessage('error', 'Something went wrong during file download!');
      })
      .finally(() => {
        setButtonLoading(false);
      });
  };

  return (
    <Fragment>
      <div>
        <div className="d-flex flex-wrap mt-3">
          <div className="me-3" style={{ flex: '1 1 30%', maxWidth: '30%' }}>
            <DropDown
              isSearchable={true}
              label={"Department"}
              placeholder={"Select department"}
              options={departmentList}
              value={departmentId}
              onChange={(value) => {
                setProcessList([]);
                handleList("department", value.value);
                setDepartmentId(value);
              }}
            />
          </div>
          <div className="me-3" style={{ flex: '1 1 30%', maxWidth: '30%' }}>
            <DropDown
              isSearchable={true}
              label={"Master process"}
              placeholder={"Select master process"}
              options={masterProcessList}
              value={masterProcessId}
              onChange={(value) => {
                handleList("masterProcess", value.value);
                setMasterProcessId(value);
              }}
            />
          </div>
          <div className="me-3" style={{ flex: '1 1 30%', maxWidth: '30%' }}>
            <DropDown
              isSearchable={true}
              label={"Process"}
              placeholder={"Select process"}
              options={processList}
              value={processId}
              onChange={(value) => {
                setProcessId(value);
              }}
            />
          </div>
        </div>
        <div className="d-flex flex-wrap mt-3">
          <div className="me-3" style={{ flex: '1 1 30%', maxWidth: '30%' }}>
            <DropDown
              isSearchable={true}
              label={"Payment Type"}
              placeholder={"Select Payment Type"}
              options={paymentTypeList}
              value={selectedPaymentType}
              onChange={(value) => setSelectedPaymentType(value)}
            />
          </div>
          <div className="me-3" style={{ flex: '1 1 30%', maxWidth: '30%' }}>
            <DropDown
              isSearchable={true}
              label={"Payment Status"}
              placeholder={"Select Payment Status"}
              options={paymentStatusList}
              value={selectedPaymentStatus}
              onChange={(value) => setSelectedPaymentStatus(value)}
            />
          </div>
          <div className="me-3" style={{ flex: '1 1 30%', maxWidth: '30%' }}>
            <label className="form-label" style={{ marginTop: "2px" }}>
              Company
            </label>
            <input
              className="p-1 form-control w-100"
              type="text"
              onChange={(e) => setCompanyName(e.target.value)}
              value={companyName}
              placeholder="Please enter company.."
            />
          </div>
        </div>
        <div className="d-flex flex-wrap mt-2">
          <div className="me-3" style={{ flex: '1 1 30%', maxWidth: '30%' }}>
            <label className="form-label">Date Range</label>
            <div className="d-flex">
              <input
                type="date"
                className="form-control me-2"
                value={dueDateStart}
                onChange={(e) => setDueDateStart(e.target.value)}
                placeholder="Start Date"
              />
              <input
                type="date"
                className="form-control"
                value={dueDateEnd}
                onChange={(e) => setDueDateEnd(e.target.value)}
                placeholder="End Date"
              />
            </div>
          </div>
        </div>
      </div>
      <div className="d-flex justify-content-start mt-3">
        <LoadingButton isLoading={isLoading} onChange={handleSubmit}>
          Search
        </LoadingButton>
        <div className="mx-5">
          <LoadingButton onChange={handleClear}>
            Clear
          </LoadingButton>
        </div>
        <div className="ms-auto" style={{ marginRight: "20px" }}>
          <button type="button" disabled={buttonLoading} className="d-flex align-items-center btn btn-primary font-weight-bold" onClick={handleExport}>
            {t("refunds.export")} {buttonLoading && <Loader type="Oval" color="#fff" height={20} width={20} style={{ marginLeft: '10px' }} />}
          </button>
        </div>
      </div>
      <div className="table-responsive" style={{ width: '100%', overflowX: 'scroll' }}>
        <DataTable
          columns={columns}
          currentPage={currentPage}
          data={jobs}
          setCurrentPage={setCurrentPage}
          totalCount={totalCount}
        />
      </div>
    </Fragment>
  );
}

export default CorporateJobs;
